export default {
  labels: {
    field: 'Campo'
  },

  directions: {
    ASC: 'Ascendente',
    DESC: 'Descendente'
  }
}
